
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","stroke":"#000","fill":"none","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_c('line',{attrs:{"x1":"16","y1":"11.172","x2":"15.999","y2":"19.497"}}),_c('polygon',{attrs:{"points":"16,3.34 1.382,28.66 30.618,28.66"}}),_c('line',{attrs:{"stroke-linecap":"round","transform":"matrix(1.6 0 0 1.6 15.988 23.972)"}})])
      }
    
      }
    